module.exports = __webpack_public_path__ + "img/block6.b43eb459.png";